var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',{staticClass:"headerHeading"},[_vm._v(_vm._s(_vm.$t("Customer.ViewAppointment.Booking_Details")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }